const initAttachinary = () => {
  $('.attachinary-input').attachinary();
}

export default initAttachinary;
